import apiFetch from '../apiFetch'

export default function () {	
	return apiFetch({endPoint: `AiStation/getDatosAnalisis`, method: 'GET', body: null})						
}
